/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ValidateLegalEntity200Response,
  ValidateLegalEntityRequest,
} from '../models/index';
import {
    ValidateLegalEntity200ResponseFromJSON,
    ValidateLegalEntity200ResponseToJSON,
    ValidateLegalEntityRequestFromJSON,
    ValidateLegalEntityRequestToJSON,
} from '../models/index';

export interface ValidateLegalEntityOperationRequest {
    validateLegalEntityRequest: ValidateLegalEntityRequest;
}

/**
 * 
 */
export class LegalEntitiesApi extends runtime.BaseAPI {

    /**
     */
    async validateLegalEntityRaw(requestParameters: ValidateLegalEntityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ValidateLegalEntity200Response>> {
        if (requestParameters['validateLegalEntityRequest'] == null) {
            throw new runtime.RequiredError(
                'validateLegalEntityRequest',
                'Required parameter "validateLegalEntityRequest" was null or undefined when calling validateLegalEntity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/legal-entities/validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateLegalEntityRequestToJSON(requestParameters['validateLegalEntityRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ValidateLegalEntity200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async validateLegalEntity(requestParameters: ValidateLegalEntityOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ValidateLegalEntity200Response> {
        const response = await this.validateLegalEntityRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
